import SituacaoIdDescricaoBase from '@/dominio/SituacaoIdDescricaoBase';

/**
 * Enum para estados de sustentação oral.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const ESTADO_SUSTENTACAO_ORAL = {
    SEM_INFORMACAO:      { id: 'SEM_INFORMACAO',      codigo: 99, descricao: 'Sem registro'                         },
    SUSTENTOU:           { id: 'SUSTENTOU',           codigo: 1,  descricao: 'Sustentou'                            },
    NAO_SUSTENTOU:       { id: 'NAO_SUSTENTOU',       codigo: 2,  descricao: 'Não sustentou'                        },
    TEVE_ASSEGURADA:     { id: 'TEVE_ASSEGURADA',     codigo: 3,  descricao: 'Teve sustentação oral assegurada'     },
    NAO_TEVE_ASSEGURADA: { id: 'NAO_TEVE_ASSEGURADA', codigo: 4,  descricao: 'Não teve sustentação oral assegurada' }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de presença de representante de parte.
 * @readonly
 */
export default class EstadoSustentacaoOral {
    static situacaoBase = new SituacaoIdDescricaoBase(ESTADO_SUSTENTACAO_ORAL);
    static MSG_ERRO_IDENTIFICACAO_ESTADO_SUSTENTACAO_ORAL =
        'Não foi possível identificar o estado da sustentação oral.';

    static getDescricao(id) {
        return EstadoSustentacaoOral.situacaoBase.getDescricao(id);
    }

    static getDescricaoByCodigo(codigo) {
        const obj = EstadoSustentacaoOral.situacaoBase.getObjectByProperty('codigo', codigo);

        if (!obj) {
            console.debug(`Estado de sustentação oral "${codigo}" desconhecido.`);
            return ESTADO_SUSTENTACAO_ORAL.SEM_INFORMACAO.descricao;
        }

        return EstadoSustentacaoOral.getDescricao(obj.id);
    }

    static getCodigo(id) {
        return EstadoSustentacaoOral.situacaoBase.getValorPropriedade(id, 'codigo');
    }

    static getIdByCodigo(codigo) {
        if (!codigo) {
            return ESTADO_SUSTENTACAO_ORAL.SEM_INFORMACAO.id;
        }

        const obj = EstadoSustentacaoOral.situacaoBase.getObjectByProperty('codigo', codigo);

        if (!obj) {
            console.debug(`Estado de sustentação oral "${codigo}" desconhecido.`);
        }

        return obj ? obj.id : '';
    }
}
